import {Button} from 'antd';
import React from 'react';
import './action-area.scss';

export interface ActionButton {
    text: string;
    onClick?: () => void;
    type?: 'primary';
}

export interface ActionAreaProps {
    className?: string;
    buttons?: ActionButton[];
}

const ActionArea: React.FC<ActionAreaProps> = (props) => {
    const {className, buttons} = props;

    return (
        <div className={`actionAreaContainer ${className || ''}`}>
            <div className="buttons">
                {buttons?.map((item) => (
                    <Button key={item.text} onClick={item.onClick} className="button" type={item.type}>
                        {item.text}
                    </Button>
                ))}
            </div>
        </div>
    );
};

export default ActionArea;
